import { useEffect } from 'react';

/**
 * Do something whenever the user clicks anywhere.
 *
 * Ignore clicks on the references in the `except` list.
 */
const useClickAnywhere = ({ except = [], onClick }) => {
  useEffect(() => {
    const onOutsideClick = (e) => {
      const ignoreClick = except.some((ref) => ref.current?.contains(e.target));

      if (!ignoreClick) {
        onClick();
      }
    };

    document.addEventListener('click', onOutsideClick);

    return () => {
      document.removeEventListener('click', onOutsideClick);
    };
  }, [onClick]);
};

export default useClickAnywhere;
